import type { AxiosPromise } from 'axios'
import request from '@core/request'
import useAppStore from '@views/app.store'
import type { GeoEffectV2ReqDto, KeysetPageResp } from './types'

export type FileType = {
  id: string
  fileFormat: string
  fileSize: number
  fileName: string
  filePath: string
  result?: { filePath: string; fileFormat: string; success: boolean }
}
export type SessionCreateData = {
  files: FileType[]
  keywords: string[]
  text: string
}
/**
 * @method sessionCreate 创建会话
 * @param data SessionCreateData
 * @returns sessionId 会话ID
 */
export function sessionCreate(data: SessionCreateData): AxiosPromise<{ sessionId: string }> {
  return request({
    url: '/session/create',
    method: 'post',
    data,
  })
}
export type SessionQueryData = {
  sessionId: string
  cursor: number // 初始为 0
  limit: number // 每次请求的数量
}

export interface Message {
  content: any
  messageType: 101 | 102 | 103 | 104 | 105 | 106 | 107 | 108 | 109 | 110 | 111 | 112 | 207 | 99999 // 101 会话创建 102 会话创建系统回复消息 103 用户资料提交
  openAnimate: 0 | 1
  type: number
  id: string
  createTime: string
}
/**
 * @method getMessageList 获取会话消息列表
 * @param data SessionQueryData
 * @returns
 */

export function getMessageList(data: SessionQueryData): AxiosPromise<{
  hasMore: boolean
  list: Message[]
  maxCursor: string | null
  minCursor: string | null
}> {
  return request({
    url: '/session/messageList',
    method: 'get',
    errorMessageShow: false,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
    data,
  })
}
/**
 * @method sessionList 获取当前登录账户会话列表
 * @returns
 * */
export function sessionList(data: {
  pageNum: number
  pageSize: number
  keyword?: string
}): AxiosPromise {
  return request({
    url: '/session/sessionList',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}
// 确认知识库
export function confirmKnowledge(data): AxiosPromise {
  return request({
    url: '/session/confirmKnowledge',
    method: 'post',
    data,
  })
}
// 未确认知识库原因
export function addUnConfirmKnowledgeReason(data: {
  knowledgeIds: string[]
  reason: string
  sessionId: string
}): AxiosPromise {
  return request({
    url: '/session/addUnConfirmKnowledgeReason',
    method: 'post',
    data,
  })
}
// 更新消息状态
export function updateMessageStatus(data: string): AxiosPromise {
  return request({
    url: '/session/updateMessageStatus',
    method: 'get',
    data: { msgId: data },
  })
}

// ai提示词列表
export function keyWordList(data: any): AxiosPromise {
  return request({
    url: '/session/keyWordList',
    method: 'get',
    data,
  })
}

// 知识库列表查询接口
export function knowledgeList(data: any): AxiosPromise {
  return request({
    url: '/session/knowledgeList',
    method: 'get',
    data,
  })
}
export type AssessType = {
  assessName: string
  text: string
  url: string
  modelList: string[]
  language?: string
  conversationType?: 2 | 6
}

export function assessCreate(data: AssessType): AxiosPromise {
  return request({
    url: '/assess/create',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}
export function assessCreateSearchTask(data: {
  keywords: string[]
  sessionId: string
}): AxiosPromise {
  return request({
    url: '/assess/createSearchTask',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}

// 提示词补充资料
export function addInformation(data: any): AxiosPromise {
  return request({
    url: '/session/addInformation',
    method: 'post',
    data,
  })
}

//
export function pubWorkflow(data): AxiosPromise {
  return request({
    url: '/session/pubWorkflow',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  }).finally(() => {
    // 需要固定触发权益接口,更新权益
    useAppStore().getAssessResidualEquityNum()
  })
}
// 编辑AI生成的企业信息和语料库内容
export function updateFileContent(data): AxiosPromise {
  return request({
    url: '/session/updateFileContent',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}
// 编辑AI生成的文章
export function updateArticleContent(data): AxiosPromise {
  return request({
    url: '/session/updateArticleContent',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}
// 获取当前回话的文章ID
export function getArticleFileId(data): AxiosPromise {
  return request({
    url: `/session/getArticleFileId?SessionId=${data}`,
    method: 'get',
  })
}

// 评估创建会话
export function assessCreateSession(data: any): AxiosPromise {
  return request({
    url: '/assess/createSession',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}

export function addAssessInformation(data: any): AxiosPromise {
  return request({
    url: 'assess/addInformation',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}

// 评估总结
export function assessEffectSummary(data: any): AxiosPromise {
  return request({
    url: '/firecrawl/effectSummary',
    method: 'post',
    data,
    errorMessageShow: false,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}
// 评估列表（V1 页码分页，/view-effect 使用）
export function assessEffectList(data: any): AxiosPromise {
  return request({
    url: '/firecrawl/effectList',
    method: 'post',
    data,
    errorMessageShow: false,
  })
}
// 评估列表（V2 游标分页）
export function assessEffectListV2(data: GeoEffectV2ReqDto): AxiosPromise<KeysetPageResp> {
  return request({
    url: '/firecrawl/effectListV2',
    method: 'POST',
    data,
    errorMessageShow: false,
  })
}
export function assessQuickCreate(data: any): AxiosPromise {
  return request({
    url: '/assess/quickCreate',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}
// 评估重启任务
export function assessNodeTaskRestart(data: any): AxiosPromise {
  return request({
    url: '/assess/nodeTaskRestart',
    method: 'post',
    data,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}
// 评估更新消息内容
export function assessUpdateMsgContent(data: any): AxiosPromise {
  return request({
    url: '/session/updateMsgContent',
    method: 'post',
    data,
    errorMessageShow: false,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}

// 评估会话详情
export function assessSessionDetail(data: any): AxiosPromise {
  return request({
    url: '/assess/sessionDetail',
    method: 'post',
    data,
    errorMessageShow: false,
    // baseURL: 'http://192.168.26.214:8080/',
    // baseURL: 'http://192.168.26.15:8080/',
  })
}

// 关键词收录效果（V1 分页，/home/statistical/data 关键词报表使用）
export function keywordEffectList(data: any): AxiosPromise {
  return request({
    url: '/dataCenter/keywordEffectList',
    method: 'post',
    data,
    errorMessageShow: false,
  })
}
// 关键词收录效果（V2 游标）
export function keywordEffectListV2(data: GeoEffectV2ReqDto): AxiosPromise<KeysetPageResp> {
  return request({
    url: '/dataCenter/keywordEffectListV2',
    method: 'POST',
    data,
    errorMessageShow: false,
  })
}
// 关键词报表
export function keywordSummary(data: any): AxiosPromise {
  return request({
    url: '/dataCenter/keywordSummary',
    method: 'post',
    data,
    errorMessageShow: false,
    // baseURL: 'http://192.168.26.214:8080/'
  })
}
// 月报管理列表
export function monthReportList(data: any): AxiosPromise {
  return request({
    url: '/dataCenter/monthReportList',
    method: 'get',
    data,
    errorMessageShow: false,
    // baseURL: 'http://192.168.26.214:8080/'
  })
}
